import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useListFeatureFlags } from "@/lib/api-extra";

interface FeatureFlagsContextValue {
  enabledFlags: Set<string>;
  isLoading: boolean;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({
  enabledFlags: new Set(),
  isLoading: true,
});

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const { data, isLoading } = useListFeatureFlags();

  const enabledFlags = useMemo(() => {
    const set = new Set<string>();
    for (const f of data?.data ?? []) {
      if (f.enabled) set.add(f.key);
    }
    return set;
  }, [data]);

  return (
    <FeatureFlagsContext.Provider value={{ enabledFlags, isLoading }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export function useFeatureFlagsContext() {
  return useContext(FeatureFlagsContext);
}
